import AboutStyles from "./About.module.css"
import BordersStyles from './Borders.module.css';
import OpenBookCover from "./photos/BookDecorWebP/BookofAbdul_BookCover.webp";
import FrontBookCover from "./photos/BookDecorWebP/BookofAbdul_FrontBookCover.webp";
import BackBookCover from "./photos/BookDecorWebP/BookofAbdul_BackBookCover.webp";
import IndividualPage from "./photos/BookDecorWebP/BookofAbdul_Pages(Individual).webp";
import SigilDec from "./photos/BookDecorWebP/BookofAbdul_SigilDecoration.webp";
import BookofAbdulFrontLogo from "./photos/BookDecorWebP/BookofAbdul_Logo(FrontCoverV2).webp";
import BookofAbdulBackLogo from "./photos/BookDecorWebP/BookofAbdul_Logo(BackCoverV2).webp";
import AbdulPic from "./photos/BookContent/About/abdul.jpg";
import { AboutLayout, TimelineLayout } from "./Borders";
import { HeaderElement } from "./Header";

const open = 
    {
        title: "OpenBookCover",
        photo: OpenBookCover,
        id: 1
    };

const page = 
    {
        title: "IndividualPage",
        photo: IndividualPage,
        id: 2
    };

const logo = 
    {
        title: "BookofAbdulFrontLogo",
        photo: BookofAbdulFrontLogo,
        id: 3
    };

const logo2 = 
    {
        title: "BookofAbdulBackLogo",
        photo: BookofAbdulBackLogo,
        id: 4
    };

const decs = 
    {
        title: "SigilDecoration",
        photo: SigilDec,
        id: 5
    };

const front = 
    {
        title: "FrontBookCover",
        photo: FrontBookCover,
        id: 6
    };

const back = 
    {
        title: "BackBookCover",
        photo: BackBookCover,
        id: 7
    };

const pagenums = 13;

export function About() {

    const Info = {
        webdescription: `If you've reached this page, you discovered by now that this website
        that resembles a digital book holds several projects I've worked on over the years.
        Through React, CSS and my own designs from scratch, I created this website to show the contents
        of my book. Hope you don't judge me too much by my cover.`,
        profdescription: `I am a recent Computer Science graduate who has been passionate about the field 
        since childhood. I have worked with Java, JavaScript, HTML, CSS, React and Node.js.
        No matter what obstacles I face, I take them one line of code at a time. \n
        \n
        Website Design © 2025 Abdul Barrie; Original HTML5, CSS3 and JS logos by W3C, 
        React logo by Facebook, NodeJS logo by OpenJS, modified by me.`,
        githublink: "https://github.com/abdulbarrie",
        deviantartlink: "https://www.deviantart.com/pantheonradiance",
        linkedinlink: "https://www.linkedin.com/in/abdul-barrie-6b2845248/",
        mediumlink: "https://medium.com/@pantheonradiance",
        pic: AbdulPic,
        picalt: "My profile picture."
    };
    
    // Trick to make animation play only on header click.
    let value = false;
    if (HeaderElement.GetHeader === "BoA-header-about") {
        value = true;
    }
    console.debug("Test value? " + value);

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={AboutStyles["BoA-individual-pages"]} value={value}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Aboutpage-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "10"}}>
                <AboutLayout
                section="About"
                img1={decs.photo}
                alt1={decs.title}
                img2={logo.photo}
                alt2={logo.title}
                img3={logo2.photo}
                alt3={logo2.title}
                description1={Info.webdescription}
                description2={Info.profdescription}
                link1={Info.githublink}
                link2={Info.deviantartlink}
                link3={Info.linkedinlink}
                link4={Info.mediumlink}
                mypic={Info.pic}
                mypicalt={Info.picalt}/>
            </div>
        </section>
    );
}

export function About2() {

    const Events = {
        Event1: `Childhood: Immersed in art of computing and writing.`,
        Event2: `2019: Enrolled in San Francisco State University (SFSU).`,
        Event3: `2021: Joined ACM Club as Front-End Web Developer.`,
        Event4: `2021-2023: Contributed to multiple projects in Web and Software Development`,
        Event5: `2023: Graduated SFSU with B.S. in Computer Science 
        and Minor in Comparative World Literature, magna cum laude.`

    };
    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={AboutStyles["BoA-individual-pages"]} id={AboutStyles["BoA-About2-pages"]}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Aboutpage-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "11"}}>
                <TimelineLayout 
                section="Timeline"
                img1={decs.photo}
                alt1={decs.title}
                event1={Events.Event1}
                event2={Events.Event2}
                event3={Events.Event3}
                event4={Events.Event4}
                event5={Events.Event5}/>
            </div>
        </section>
    );
}